import React, { Component } from 'react';
import { Row, Image, Nav, NavItem, Tab, PanelGroup, Panel, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { contractReviewerActions as actions, analysisActions } from '../../actions';
import { contractReviewerConstants } from '../../constants';
import DocumentSettings from './DocumentSettings';
import { PrivateRoute } from '../PrivateRoute';
import '../../content/css/ContractReviewer.css';
import { LoadingIcon } from '../LoadingIcon';
import LoadingListener from '../../helpers/loadingListener';
import ReactMarkdown from 'react-markdown';
import AuthService from "../../services/auth.service";

var page_highlighted1 = require("../../content/images/page_highlighted_icon[1].png");
var page_highlighted2 = require("../../content/images/page_highlighted_icon[2].png");
var page_highlighted3 = require("../../content/images/page_highlighted_icon[3].png");

class Overview extends Component {
    constructor(props, context) {
        super(props, context);
        this.loadingListener = new LoadingListener([
            contractReviewerConstants.GET_DOCUMENT_ANALYSIS_REQUEST,
            contractReviewerConstants.GET_DOCUMENT_SUMMARY_REQUEST
        ]);
        this.state = { activeTab: 'highlights' };

        this.authService = new AuthService();
    }

    componentDidMount() {
        const { reportId, docId } = this.props.match.params;

        if (this.props.id !== docId || this.props.shouldRefreshAnalysis) {
            this.props.requestDocumentAnalysis(docId, reportId);
        }

        if (reportId) {
            if (this.props.reportId !== reportId) {
                this.props.requestPortfolioAnalysis(reportId);
            }
        } else {
            this.props.deselectPortfolioAnalysis();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.shouldRefreshAnalysis) {
            setTimeout(() => this.props.requestDocumentAnalysis(this.props.id), this.props.refreshAnalysisDelay * 1000);
        }

        if (this.props.exceptions !== prevProps.exceptions && this.props.exceptions.length > 0) {
            throw this.props.exceptions[0];
        }

        if (this.props.id !== prevProps.id) {
            this.requestSummaryAndFeedback(this.props.id);
        }
    }

    requestSummaryAndFeedback = (docId) => {
        if (!this.authService.userAllowsThirdPartyAI()) {
            return;
        }

        this.props.getDocumentSummaryAndFeedback(docId);
    }

    handleRefreshSummary = () => {
        if (!this.authService.userAllowsThirdPartyAI()) {
            return;
        }
        this.props.getDocumentSummaryAndFeedback(this.props.id, true);
    }

    getCurrentDocument = () => {
        if (this.props.analyzedDocuments && this.props.analyzedDocuments.hasOwnProperty(this.props.id)) {
            return this.props.analyzedDocuments[this.props.id];
        }
        return { summary: null, highlights: [], missingHighlights: [], segments: [] };
    }

    getPages() {
        const doc = this.getCurrentDocument();
        const highlights = doc.highlights;
        const pages = [];
        for (let i = 0; i < highlights.length; i++) {
            const segment = highlights[i];
            let img = (
                <Image
                    className={`page${segment.isActive ? "" : " disabled"}`}
                    src={this.getRandomPageIcon()}
                    fluid
                />
            );
            let linkBase = this.props.reportId ? `/reports/${this.props.reportId}/document` : "";
            if (segment.isActive) {
                pages.push(
                    <LinkContainer key={i} to={`${linkBase}/${this.props.id}/viewer/${i + 1}`}>
                        {img}
                    </LinkContainer>
                );
            } else {
                pages.push(<span key={i}>{img}</span>);
            }
        }
        return pages;
    }

    getRandomPageIcon() {
        let n = Math.random() * 10;
        return n > 6 ? page_highlighted1 : (n < 4 ? page_highlighted2 : page_highlighted3);
    }

    getContractTypeSpan() {
        let link = `/${this.props.id}/settings`;
        let doc = this.getCurrentDocument();
        let adjective = "a";
        let text = "";

        switch (doc.contractType) {
            case "ProcurementAgreement": text = "Procurement agreement"; break;
            case "CustomerAgreement": text = "Customer agreement"; break;
            case "NDA_Customer": text = "NDA - receiving information"; adjective = "an"; break;
            case "NDA_Seller": text = "NDA - giving information"; adjective = "an"; break;
            case "NDA_Mutual": text = "NDA - giving/receiving information"; adjective = "an"; break;
            case "EULA_Seller": text = "EULA - Seller"; adjective = "an"; break;
            case "EULA_Customer": text = "EULA - Customer"; adjective = "an"; break;
            case "DistributionAgreement_Customer": text = "Distribution agreement - Customer"; break;
            case "DistributionAgreement_Seller": text = "Distribution agreement - Seller"; break;
            case "LicenseAgreement_Customer": text = "License agreement - Customer"; break;
            case "LicenseAgreement_Seller": text = "License agreement - Seller"; break;
            case "SourcingOfGoods_Customer": text = "Source of Goods agreement - Customer"; break;
            case "SourcingOfGoods_Seller": text = "Source of Goods agreement - Seller"; break;
            case "DPA_Controller": text = "DPA - Controller"; break;
            case "DPA_Processor": text = "DPA - Processor"; break;
            case "Services_Customer": text = "Services - When you are the buyer"; break;
            case "Services_Seller": text = "Services - When you are the seller"; break;
            case "PersonalServices_Customer": text = "Personal Services - Customer"; break;
            case "PersonalServices_Seller": text = "Personal Services - Seller"; break;
            case "CarrierAgreement": text = "Carrier agreement"; break;
            case "BrokerAgreement": text = "Broker agreement"; break;
            case "Unknown": text = "unknown"; adjective = "an"; break;
            default: text = "unknown"; adjective = "an"; break;
        }

        return (
            <span className="contract-type">
                This is {adjective} <LinkContainer to={link}><strong>{text}</strong></LinkContainer>. Click to change theme.
            </span>
        );
    }

    renderSummaryTabs() {
        const doc = this.getCurrentDocument();
        const isLoading = this.loadingListener.isLoading(this.props.isLoading);

        if (isLoading) {
            return <LoadingIcon />;
        }

        if (!doc)
            return;

        if (!this.authService.userAllowsThirdPartyAI()) {
            return this.renderHighlightsTab(doc.highlights);
        }

        const data = doc.summary ? doc.summary : {};

        return (
            <Tab.Container id="overview-tabs" activeKey={this.state.activeTab} onSelect={(k) => this.setState({ activeTab: k })}>
                <div>
                    <Nav bsStyle="pills">
                        <NavItem eventKey="highlights">Found clauses</NavItem>
                        <NavItem eventKey="summary">Summary</NavItem>
                        <NavItem eventKey="topics">Key Topics</NavItem>
                        <NavItem eventKey="guidance">What to do next</NavItem>
                    </Nav>
                    <Tab.Content animation>
                        <Tab.Pane eventKey="highlights">
                            {this.renderHighlightsTab(doc.highlights)}
                        </Tab.Pane>
                        <Tab.Pane eventKey="summary">
                            <ReactMarkdown className="summary-box" source={data.summary ? data.summary : 'No summary available.'} />
                            <Button onClick={this.handleRefreshSummary}>Refresh AI summary</Button>
                        </Tab.Pane>
                        <Tab.Pane eventKey="topics">
                            {this.renderTopics(data.topics)}
                        </Tab.Pane>
                        <Tab.Pane eventKey="guidance">
                            {this.renderGuidance(data.actionableGuidance)}
                        </Tab.Pane>
                    </Tab.Content>
                </div>
            </Tab.Container>
        );
    }

    renderHighlightsTab(highlights) {
        if (!highlights || highlights.length === 0) {
            return <p className="empty-state">No highlights found in this document.</p>;
        }

        return (
            <div className="pages">
                {this.getPages()}
            </div>
        );
    }

    renderTopics(topics) {
        if (!topics || topics.length === 0) {
            return <p className="empty-state">No specific topics were identified in the contract.</p>;
        }

        return (
            <PanelGroup accordion id="overview-topics-accordion">
                {topics.map((topic, index) => (
                    <Panel key={index} eventKey={index.toString()}>
                        <Panel.Heading>
                            <Panel.Title toggle>{topic.topicName}</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                            <ReactMarkdown source={topic.explanation ? topic.explanation : 'No content.'} />
                        </Panel.Body>
                    </Panel>
                ))}
            </PanelGroup>
        );
    }

    renderGuidance(guidance) {
        if (!guidance || guidance.length === 0) {
            return <p className="empty-state">No actionable guidance was provided.</p>;
        }

        return (
            <ul className="actionable-guidance-list">
                {guidance.map((item, index) => (
                    <li key={index}><ReactMarkdown source={item} /></li>
                ))}
            </ul>
        );
    }

    render() {
        const doc = this.getCurrentDocument();
        const isLoading = this.loadingListener.isLoading(this.props.isLoading);
        const wasAnalysisSuccessful = doc.wasSuccessful;
        const highlights = doc.highlights;
        const missingHighlights = doc.missingHighlights;
        const linkBase = this.props.reportId ? `/reports/${this.props.reportId}/document` : "";

        return (
            <div className="overview">
                {isLoading ? <LoadingIcon isFixed={true} /> :
                    <React.Fragment>
                        {missingHighlights.length > 0 &&
                            <LinkContainer to={`${linkBase}/${this.props.id}/missing`}>
                                <div className="missing-concepts-warning">
                                    <div className="icon-wrapper"><div className="icon">!</div></div>
                                    <span><strong>Important clauses are missing from your document! Click to learn more.</strong></span>
                                </div>
                            </LinkContainer>
                        }

                        <Row>
                            <p className="title">Your document: <strong>{doc.fileName}</strong></p>
                            <hr />
                            {wasAnalysisSuccessful ?
                                <React.Fragment>
                                    <span className="title">We found <strong>{highlights.length}</strong> {highlights.length !== 1 ? "clauses" : "clause"} you need to take a closer look at.</span>
                                    {this.getContractTypeSpan()}
                                </React.Fragment>
                                : null}
                        </Row>

                        {!wasAnalysisSuccessful ?
                            <DocumentSettings {...this.props} hideBackButton={true} />
                            : null}

                        <Switch>
                            <PrivateRoute path={`${this.props.match.path}/settings`} component={(props) => (
                                <DocumentSettings {...props} {...this.props} />
                            )} />
                            <PrivateRoute path={this.props.match.path} component={() => (
                                this.renderSummaryTabs()
                            )} />
                        </Switch>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { contractReviewer, analysis } = state;
        return {
            ...contractReviewer,
            reportId: analysis.id
        };
    },
    dispatch => bindActionCreators({
        ...actions,
        requestPortfolioAnalysis: analysisActions.requestPortfolioAnalysis,
        deselectPortfolioAnalysis: analysisActions.deselectPortfolioAnalysis,
    }, dispatch)
)(Overview);



// WEBPACK FOOTER //
// ./src/components/Home/Overview.js